import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseFieldControlComponent } from '@d-components/base-field-control/base-field-control';
import { TreeSelectModule } from 'primeng/treeselect';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseLabelComponent } from '@d-components/label/label.component';
import { TreeOptionsModel } from '@d-components/form/form.interface';
import { flatMapDeep } from 'lodash';

@Component({
  selector: 'app-base-dropdown-tree',
  standalone: true,
  imports: [
    CommonModule,
    TreeSelectModule,
    ReactiveFormsModule,
    BaseLabelComponent,
    FormsModule,
  ],
  templateUrl: './dropdown-tree.component.html',
  styleUrls: ['./dropdown-tree.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BaseDropdownTreeComponent
  extends BaseFieldControlComponent
  implements OnInit, OnChanges
{
  @Input() options: TreeOptionsModel[] = [];
  @Input() placeholder: string = 'Select';
  @Output() onChange = new EventEmitter();

  sortedOptions!: TreeOptionsModel[];

  selectedValue!: TreeOptionsModel | undefined;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.formatOptions();

    if (this.fieldControl.value) {
      this.updateSelected(this.fieldControl.value, this.options);
    }

    this.fieldControl.valueChanges.subscribe((val) => {
      this.updateSelected(val, this.options);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('options')) {
      this.formatOptions();
    }
  }

  handleOnNodeSelect(event: any) {
    this.fieldControl.setValue(event.node.value);
    this.onChange.emit(event.node);
  }

  private updateSelected(value: string, list: TreeOptionsModel[]) {
    const item = this.getItemByValue(this.fieldControl.value, this.options);
    this.selectedValue = item;
  }

  private getItemByValue(
    value: string,
    list: TreeOptionsModel[],
  ): TreeOptionsModel | undefined {
    let rs;
    for (let item of list) {
      if (item.value === value) return item;
      if (item.children && item.children.length) {
        rs = this.getItemByValue(value, item.children);
        if (rs) return rs;
      }
    }
    return rs;
  }

  private formatOptions() {
    this.sortedOptions = this.sortOptions(this.options);
    this.updateSelected(this.fieldControl.value, this.options);
  }

  private sortOptions(list: TreeOptionsModel[]): TreeOptionsModel[] {
    return list.sort((a: any, b: any) => {
      if (a.hasOwnProperty('children')) {
        a.children = this.sortOptions(a.children);
      }

      if (a.label > b.label) return 1;
      if (a.label < b.label) return -1;
      return 0;
    });
  }
}
